import React from 'react';
import styles from './NewPaymentSummary.module.scss';

interface Props {
  planName: string | null;
  cost: number;
  originalCost: number;
}

const NewPaymentSummary = ({ planName, cost, originalCost }: Props) => {
  if (!planName) {
    return null;
  }

  const savings = originalCost - cost;
  const hasDiscount = savings > 0;

  return (
    <div className={styles.summary}>
      <div className={styles.row}>
        <span className={styles.label}>Plan seleccionado</span>
        <span className={styles.value}>{planName}</span>
      </div>

      {hasDiscount ? (
        <>
          <div className={styles.row}>
            <span className={styles.label}>Precio original</span>
            <span className={styles.value}>
              $&nbsp;{originalCost.toLocaleString('es-CO')}
            </span>
          </div>
          <div className={styles.row}>
            <span className={styles.label}>Descuento por cupón</span>
            <span className={styles.value} style={{ color: '#18b9a7' }}>
              - $&nbsp;{savings.toLocaleString('es-CO')}
            </span>
          </div>
        </>
      ) : (
        <div className={styles.row}>
            <span className={styles.label}>Precio</span>
            <span className={styles.value}>
              $&nbsp;{originalCost.toLocaleString('es-CO')}
            </span>
        </div>
      )}

      <div className={styles.totalRow} style={{ borderTop: '1px solid #e2e8f0', paddingTop: '12px', marginTop: '12px' }}>
        <span className={styles.label}>Total a pagar</span>
        <span className={styles.value}>$&nbsp;{cost.toLocaleString('es-CO')}</span>
      </div>
    </div>
  );
};

export default NewPaymentSummary;